import IonDatePicker from './src/ion-date-picker.vue';

IonDatePicker.install = function install(_vue) {
  _vue.component(IonDatePicker.name, IonDatePicker);
};
export default IonDatePicker;
